<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10KfQni/tc-custom/9781439675243.jpg?1705026047291" alt="This image is the cover for the book Minneapolis Murder & Mayhem, Murder & Mayhem"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Minneapolis Murder & Mayhem, Murder & Mayhem
      </h1>
      <p class="bookDescription body article font2">
        <p>Minneapolis has a bloody, unacknowledged heritage. On the shore of Lake Harriet, Ojibwe warriors killed a Dakota man, triggering two retaliatory massacres. Ten years later, pioneer settlers roved the land of Minneapolis in gangs for protection from other pioneer gangs. When a lynch mob hanged a violent criminal across the street from Central High School, they left his corpse dangling for hours. Rioting Riversiders toppled a streetcar and attacked the driver. A man murdered a kind stranger because he misunderstood his intentions. Separate industrial disasters shattered the St. Anthony Falls, causing one fatality, and nearly razed the Mill District, killing eighteen more and injuring countless others. Author Ron de Beaulieu uncovers the dark, sinister history beneath the city.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ron de Beaulieu
      </h2>
      
      <p class="authorDescription body article">Ron de Beaulieu has lived in South Minneapolis for about six years, and no amount of snow has kept her from walking along Minnehaha Creek almost every day. Before that, when she lived in Southeast, no amount of snow kept her from walking along the Mississippi River almost every day (wind chill was a different story). Exploring the Mill City never gets old for Ron. She has earned graduate degrees in history and sociology, with a focus on criminology. She considers herself lucky to have had the opportunity to combine her research interests with her hobby.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0860f98c